import { ProductV2 } from '@common'
import cx from 'classnames'
import { useTranslations } from 'next-intl'

import { useAppSelector } from '@/utils/useAppSelector'

import { CardRibbon } from './CardRibbon'

import styles from './productRibbon.module.scss'

interface Props {
  product: ProductV2
  position?: 's'
  className?: string
}

function calculatePoints(product: ProductV2) {
  const pennies = product.prices?.['USD-US']
  if (!pennies) return undefined
  return Math.ceil(pennies / 2)
}

export const ProductRibbon = ({ product, position, className: additionalClasses }: Props) => {
  const t = useTranslations()
  const bonusTrackCompleted = useAppSelector((state) => state.common.bonusTrackCompleted)

  if (bonusTrackCompleted) return null
  const points = calculatePoints(product)
  const ribbonContent = points ? t('bonus_number_of_points').replace('[n]', points.toString()) : ''

  // set style as black as per designs
  return (
    <div className={cx(styles.RibbonContainer, { [styles['position-s']]: position === 's' }, additionalClasses)}>
      <CardRibbon content={ribbonContent} />
    </div>
  )
}
